// extracted by mini-css-extract-plugin
export default {"flex-column":"commentList_flex-column__fdefP","comments":"commentList_comments__QoYBG","flex-row":"commentList_flex-row__Fxc68","page-size":"commentList_page-size__FbbtD"};